import MDSpinner from 'react-md-spinner'
import colors from './Spinner.module.scss'

type singleColor = 'grey' | 'purple'

interface Props {
  size?: number
  singleColor?: singleColor
}

const Spinner = ({
  size,
  singleColor = 'grey'
}: Props) => {
  const colorStyle = {
    grey: colors.singlecolorgrey,
    purple: colors.singlecolorpurple
  }

  const spinnerColor = colorStyle[singleColor]

  return (
    <MDSpinner
      aria-hidden
      singleColor={spinnerColor}
      size={size}
    />
  )
}

export default Spinner
